import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const REAL_ESTATE_TYPES = new Set<ClientPropertyTypeEnum>([
	ClientPropertyTypeEnum.Flat,
	ClientPropertyTypeEnum.House,
	ClientPropertyTypeEnum.Cottage,
	ClientPropertyTypeEnum.Land,
]);
